// The "N × price = total / period" line every quantity add-on stepper shows —
// the buy-more modal (billing--addon-quantity) and the downgrade keep-N block
// (billing--downgrade-keep) — so both print it one way, in the billing page's
// number format (formatBillingAmount).
import { formatBillingAmount } from "./billing-amount.util"

const DEFAULT_PATTERN = "%{quantity} × %{price} = %{total} / %{period}"

// `pattern` is the server's own, uninterpolated billing.addons.quantity_modal
// .cost_line copy, so a translator reordering the sentence is honoured on every
// recompute. At zero the view's zero label wins.
export function addonCostLine({ quantity, unitPrice, currencyFormat, period, pattern, zero }) {
  if (quantity === 0) return zero || formatBillingAmount(0, currencyFormat)

  return interpolate(pattern || DEFAULT_PATTERN, {
    quantity,
    price: formatBillingAmount(unitPrice, currencyFormat),
    total: formatBillingAmount(quantity * unitPrice, currencyFormat),
    period: period || "month"
  })
}

// Fills %{key} placeholders from `values`; a placeholder with no value stays.
export function interpolate(pattern, values) {
  return pattern.replace(/%\{(\w+)\}/g, (match, key) => (key in values ? values[key] : match))
}
